
const generateBacktestReport = (data, stratergy, stratergyName, stopLoss=2, qty=1, intialCapital=1000) => {
    let report = undefined;
    let holdingPostion = 0;
    let buyPrice = 0;
    let sellPrice = 0;
    let totalBuy=0, totalSell=0, totalStopLoss=0, totalProfit = 0;
    let lastClose = 0;
    if (data != null && data.length !== null && data.length > 0) {
        for (var i = 0; i < data.length; i++) {

            let longShort = undefined;
            let evenTriggered = false;
            if (stratergy === 'EMA') {
                longShort = data[i].emaLongShort;
            }
            if (stratergy === 'RSI') {
                longShort = data[i].rsiLongShort;
            }
            if (stratergy === 'MACD') {
                longShort = data[i].macdLongShort;
            }
            if (stratergy === 'SMA') {
                longShort = data[i].smaLongShort;
            }

            //Enter position
            if (longShort !== undefined && longShort === 'LONG') {
                if (holdingPostion <= 0) {
                    holdingPostion++;
                    buyPrice = data[i].close;
                    totalBuy++;
                }
            }

            //Exit position
            if (longShort !== undefined && longShort === 'SHORT') {
                if (holdingPostion > 0) {
                    holdingPostion--;
                    sellPrice = data[i].close;
                    totalSell++;
                    evenTriggered = true;
                }
            }

            //Stop loss
            if (holdingPostion > 0 && (buyPrice - (buyPrice * stopLoss / 100)) >= data[i].close ) {
                holdingPostion--;
                totalStopLoss++;
                evenTriggered = true;
            }        
            
            if (evenTriggered){
                totalProfit = totalProfit + (sellPrice * qty) - (buyPrice * qty); 
            }
            lastClose = data[i].close; //This is formatting
        }
        report = {
            stratergy: stratergy,
            stratergyName: stratergyName,
            totalBuy: totalBuy,
            totalSell: totalSell,
            totalStopLoss: totalStopLoss,
            totalProfit: totalProfit,
            lastClose: lastClose
        }
    }
    return report;
}

export {generateBacktestReport};